module.exports = __webpack_public_path__ + "static/media/priscilla.6e390332.jpg";